import { Box, Typography, Toolbar } from '@mui/material'
import { useNavigate, Link } from 'react-router-dom'
import './index.css'
import ZendeskLinkLogin from 'components/Common/ZendeskLink/LoginPage'
import { verifyMail } from 'store/actions/authActions'
import { useCallback, useState, useContext } from 'react'
import Alert from '@mui/material/Alert'
import { useDispatch } from 'react-redux'
import { validateEmail } from 'utils/helper'
import Button from 'components/Common/Button'
import routes from 'routes'
import logoBlue from 'assets/markaazLogoBlue.svg'
import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme'
import { useParams } from 'react-router-dom'
import { AuthStateContext } from 'context/auth'

const sx = {
  styleWrap: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: '#25245f',
    minHeight: '100vh',
  },
  formField: {
    marginInline: 'auto',
    backgroundColor: 'color.blue5',
  },
  thirdParty: {
    color: 'color.blue',
    marginBottom: '50px',
    display: 'flex',
    justifyContent: 'center',
  },
  divider: {
    color: '#CEE4F5',
    margin: '20px 0px 0px',
  },
  welcomeMsg: {
    textAlign: 'center',
    margin: '40px 15px 20px',
    fontWeight: '600',
  },
  toolbarLoggedOut: {
    minHeight: '76.9px',
    background: 'transparent',
    justifyContent: 'space-between',
  },
  appBarStyle: {
    background: 'transparent',
    boxShadow: 'none',
    width: '100%',
    zIndex: '12345677',
    position: 'fixed',
  },
  logo: theme => ({
    width: '108px',
    height: '27.69px',
    [theme.breakpoints.down(813)]: {
      width: '76.58px',
      height: '19.79px',
    },
  }),
}

const EmailVerify = () => {
  const toMarkaaz = useCallback(() => {
    window.location.replace(`${'https://markaaz.com'}`)
  }, [])

  const dispatch = useDispatch()
  const [email, setEmail] = useState()
  const [spinner, setSpinner] = useState(false)
  const [inValid, setInvalid] = useState(false)
  const [showError, setShowError] = useState(false)
  const navigate = useNavigate()
  const { EPSGId } = useParams()
  const [, authDispatch] = useContext(AuthStateContext)
  const handleSubmit = e => {
    e.preventDefault()
    if (!handleEmailValidation()) {
      return
    }

    verifyMail(
      email.toLowerCase(),
      navigate,
      (val, message) => {
        setSpinner(val)
        setShowError(message)
        dispatch({
          type: 'EMAILTOVERIFY',
          payload: { email, EpsgUser: EPSGId ? EPSGId : false },
        })
        authDispatch({ type: 'signIntoSignUp', payload: email })
      },
      dispatch,
    )
  }
  // const handleMobSubmit = e => {
  //   e.preventDefault()
  //   if (!handleEmailValidation()) {
  //     return
  //   }

  //   verifyMailMob(
  //     email.toLowerCase(),
  //     navigate,
  //     val => {
  //       setSpinner(val)
  //       dispatch({
  //         type: 'EMAILTOVERIFY',
  //         payload: { email, EpsgUser: EPSGId ? EPSGId : false },
  //       })
  //       authDispatch({ type: 'signIntoSignUpMob', payload: { email: email } })
  //     },
  //     dispatch,
  //   )
  // }
  const handleEmailValidation = e => {
    const value = email
    if (!value) {
      setInvalid('This field is Required')
    } else if (!validateEmail(value)) {
      setInvalid('Please enter valid email')
    } else {
      setInvalid(false)
      return true
    }
  }

  const handleClose = () => {
    setShowError('')
  }

  return (
    <>
      <Box sx={sx.appBarStyle}>
        <Toolbar sx={sx.toolbarLoggedOut} style={{ backgroundColor: '#fff' }}>
          <Link to={routes.home} onClick={toMarkaaz}>
            <Box component="img" src={logoBlue} sx={sx.logo} alt="Markaaz" />
          </Link>
        </Toolbar>
      </Box>

      <Box sx={sx.styleWrap}>
        <Box>
          <Typography variant="h5" sx={{ textAlign: 'center', marginBottom: '25px' }}>
            Markaaz Dashboard
          </Typography>

          <Box width="330px" className="mt-3" component="form" sx={sx.formField}>
            <Box className={`my-3 authForm ${inValid ? 'inValid' : ''}`}>
              <label htmlFor="userName" className="form-label required_login">
                Email
              </label>
              <input
                onChange={e => setEmail(e.target.value)}
                name="userName"
                type="email"
                className="form-control"
                id="userName"
              />
              <Box className="errorMessage mt-1" fontSize="12px" fontWeight={400} color="#D14343">
                {inValid}
              </Box>
            </Box>
            <Box sx={{ marginTop: '5.5em' }} textAlign="center">
              <Button
                type={validateEmail(email) ? PRIMARY_BUTTON : DISABLED_BUTTON}
                sx={{ width: '220px' }}
                loading={spinner}
                onClick={handleSubmit}
                submit
              >
                Sign In
              </Button>
            </Box>
          </Box>
          <ZendeskLinkLogin />

          {showError && (
            <Alert role="alert" severity="error" className="mt-2" onClose={handleClose}>
              {showError}
            </Alert>
          )}
        </Box>
      </Box>
    </>
  )
}

export default EmailVerify
